export const corPrimaria = "#41d3b2"

export const fundoClaro = "#f1f1f1"
export const textoFundoClaro = "grey"
export const conteudoClaro = "#fff"

export const fundoEscuro = "#363537"
export const conteudoEscuro = "#5c5b5e"
export const textoFundoEscuro = "#fAfAfA"
